import { PtoV3VaultStatus } from 'Modules'
import { useCallback, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

/**
 * PTO v3 step 9 - POST /admin/pto/:id/vault-status/sync: checks the vault on-chain now
 * (verified in the IdentityRegistry + PTO balance) instead of waiting for the hook, and
 * lets the BE flip the PTO to ON_SALE when it is ready.
 */
export const useVaultStatusV3 = (id?: string | null) => {
  const [vaultStatus, setVaultStatus] = useState<PtoV3VaultStatus | null>(null)
  const [syncing, setSyncing] = useState(false)

  const syncVaultStatus = useCallback(async () => {
    if (!id) return null
    setSyncing(true)
    try {
      const res = await AppAdmin.ptoV3SyncVaultStatus(id)
      const data = res.data?.data || null
      setVaultStatus(data)
      return data
    } catch (error) {
      logError('Sync vault status failed:', error)
      throw error
    } finally {
      setSyncing(false)
    }
  }, [id])

  return { vaultStatus, syncing, syncVaultStatus }
}
